import { notifications } from "@mantine/notifications";

import { PerformRequest } from "./usePerformRequest";
import { Colors } from "./Data";

export const validateEmail = (email: string, isGmail?: boolean) => {
  const re = isGmail
    ? /^[a-zA-Z0-9._%+-]+@gmail\.com/
    : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateGmail = (email: string) => {
  const regex = /^[a-zA-Z0-9._%+-]+@gmail\.com/;
  return regex.test(email);
};
export const validatePassword = (password: string) => {
  return password.length >= 8;
};

export const getFinancialValueFromNumeric = (
  value: number | string | undefined
) => {
  if (value !== undefined) {
    return parseFloat(value.toString()).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return "...";
};

export const getFullDate = (dateString: string | undefined | any) => {
  if (dateString) {
    const d = new Date(dateString);
    const MONTHS = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const year = d.getFullYear();
    const month = MONTHS[d.getMonth()];
    const day = DAYS[d.getDay()];
    return `${day} ${d.getDate()} ${month}, ${year} `;
  }
  return dateString;
};
export const getHalfDate = (dateString: string | undefined) => {
  if (dateString) {
    const d = new Date(dateString);
    const MONTHS = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const year = d.getFullYear();
    const month = MONTHS[d.getMonth()];

    return `${month}-${d.getDate()}-${year} `;
  }
  return dateString;
};
export const generateRandomString = (length: number) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
export const DefaultErrorNotification = (message?: string, title?: string) => {
  notifications.show({
    color: "red",
    message: message ?? "An error occurred",
    title: title ?? "Error",
  });
};
export const DefaultMessageNotification = (
  message?: string,
  title?: string
) => {
  notifications.show({
    color: Colors.BluePrimary,
    message: message ?? "",
    title: title ?? "Notice",
  });
};
export const DefaultWarningNotification = (
  message?: string,
  title?: string
) => {
  notifications.show({
    color: "orange",
    message: message ?? "An error occurred",
    title: title ?? "Warning",
  });
};
export const DefaultSuccessNotification = (
  message?: string,
  title?: string
) => {
  notifications.show({
    color: "green",
    message: message ?? "Completed!",
    title: title ?? "Success",
  });
};

export const getDifferencesInObjects = (obj1: any, obj2: any) => {
  const differences: any[] = [];
  for (const key in obj1) {
    if (!(key in obj2) || obj1[key] !== obj2[key]) {
      if (!differences.includes(key)) {
        differences.push(key);
      }
    }
  }
  for (const key in obj2) {
    if (!(key in obj1) || obj2[key] !== obj1[key]) {
      if (!differences.includes(key)) {
        differences.push(key);
      }
    }
  }
  return differences;
};
export const getDiscountedValue = (amount: number, percent: number) => {
  const discount = (percent / 100) * amount;
  return amount - discount;
};

export const getOriginalValueFromDiscount = (
  amount: number,
  percent: number
) => {
  const originalAmount = amount - (percent / 100) * amount;
  return originalAmount - getDiscountedValue(originalAmount, percent);
};

export const ShowValidationError = (errors: string[]) => {
  DefaultErrorNotification(
    errors ? errors[0] ?? "Form validation error" : "Form validation error"
  );
};

export const getPaginationTotal = (
  total: number | undefined,
  limit: number
) => {
  if (total) {
    if (total <= limit) {
      return 1;
    } else {
      return Math.ceil(total / limit);
    }
  } else {
    return 1;
  }
};

export const getEllipsisFromString = (
  str: string,
  maxLength: number
): string => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "…";
  }
  return str;
};

export const trimString = (str: string, lowercase?: boolean) => {
  return str
    ? lowercase
      ? str.toString().toLowerCase()
      : str.toString().trim()
    : "";
};

export const maskEmail = (email: string) => {
  const [local, domain] = email.split("@");

  let maskedLocal;
  if (local.length <= 2) {
    maskedLocal = local[0] + "*".repeat(local.length - 1);
  } else if (local.length <= 5) {
    maskedLocal = local[0] + "*".repeat(local.length - 2) + local.slice(-1);
  } else {
    const mid = Math.floor(local.length / 2);
    maskedLocal = local.slice(0, 3) + "*".repeat(4) + local.slice(-3);
  }

  return `${maskedLocal}@****.com`;
};
